var lib_core    = require("lib-core");

var TabModel = function() {
    lib_core.Model.apply(this);

    this.expanded_toolbar = false;
    this.active = this.value("active", true);

    this.userMessage = this.value("userMessage", true);
};
lib_core.inherit(TabModel, lib_core.Model);
lib_core.JsonParser.registerClass(TabModel, "TabModel");

module.exports = TabModel;

TabModel.prototype.setActive = function () {
    this.active(true);
};

TabModel.prototype.setInactive = function () {
    this.active(false);
};

TabModel.prototype.setUserMessage = function (message, type) {
    if(message) {
        this.userMessage({
            message: message,
            type: type
        });
    } else {
        this.userMessage(null);
    }
};
